import { useQuery } from '@tanstack/react-query';
import { axiosGet } from '../api/axios';

export interface SearchQuery {
  id: number;
  query: string;
  created_at: string;
  score_results?: number[];
  client: Client;
}

export interface Client {
  name: string;
}

export const fetchSearchQueries = async (testUsers: boolean = false): Promise<SearchQuery[]> => {
  const searchParams = testUsers ? { is_test_user: 'true' } : {};
  const { data } = await axiosGet('/search', searchParams, 'v3');
  return data;
};

export const useSearchQueries = (testUsers: boolean = false) => {
  return useQuery<SearchQuery[]>(['searchQueries', testUsers], () => fetchSearchQueries(testUsers));
};
